/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/

export { GenericInstanceFilter } from "@itwin/core-common";

export {
  DefineHierarchyLevelProps,
  HierarchyLevelDefinition,
  HierarchyDefinition,
  HierarchyNodesDefinition,
  NodeParser,
  NodePostProcessor,
  NodePreProcessor,
} from "./hierarchies/imodel/IModelHierarchyDefinition.js";
export {
  DefineGenericNodeChildHierarchyLevelProps,
  DefineInstanceNodeChildHierarchyLevelProps,
  DefineRootHierarchyLevelProps,
  createPredicateBasedHierarchyDefinition,
} from "./hierarchies/imodel/PredicateBasedHierarchyDefinition.js";
export { LimitingECSqlQueryExecutor, createLimitingECSqlQueryExecutor } from "./hierarchies/imodel/LimitingECSqlQueryExecutor.js";
export { NodeSelectClauseColumnNames, NodesQueryClauseFactory, createNodesQueryClauseFactory } from "./hierarchies/imodel/NodeSelectQueryFactory.js";
export { createIModelHierarchyProvider } from "./hierarchies/imodel/IModelHierarchyProvider.js";
export { SourceHierarchyNode, ProcessedHierarchyNode } from "./hierarchies/imodel/IModelHierarchyNode.js";

export { RowsLimitExceededError } from "./hierarchies/HierarchyErrors.js";
export { GroupingHierarchyNode, HierarchyNode, NonGroupingHierarchyNode } from "./hierarchies/HierarchyNode.js";
export { HierarchyNodeIdentifier, HierarchyNodeIdentifiersPath } from "./hierarchies/HierarchyNodeIdentifier.js";
export {
  GenericNodeKey,
  GroupingNodeKey,
  HierarchyNodeKey,
  InstancesNodeKey,
  ClassGroupingNodeKey,
  LabelGroupingNodeKey,
  PropertyGroupingNodeKey,
  PropertyOtherValuesGroupingNodeKey,
  PropertyValueGroupingNodeKey,
  PropertyValueRangeGroupingNodeKey,
  IModelHierarchyNodeKey,
} from "./hierarchies/HierarchyNodeKey.js";
export { GetHierarchyNodesProps, HierarchyProvider, mergeProviders } from "./hierarchies/HierarchyProvider.js";
export {
  createHierarchyFilteringHelper,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  extractFilteringProps,
  HierarchyFilteringPath,
  HierarchyFilteringPathOptions,
} from "./hierarchies/HierarchyFiltering.js";
export { getLogger, setLogger } from "./hierarchies/Logging.js";
